let delay = window.myShopifySettings.delay * 1000;

function getTexts() {
    const texts = [];

    if (window.myShopifySettings.text1) {
        texts.push(window.myShopifySettings.text1);
    }
    if (window.myShopifySettings.text2) {
        texts.push(window.myShopifySettings.text2);
    }
    if (window.myShopifySettings.text3) {
        texts.push(window.myShopifySettings.text3);
    }
    if (window.myShopifySettings.text4) {
        texts.push(window.myShopifySettings.text4);
    }

    return texts;
}

document.addEventListener('DOMContentLoaded', function() {
    
    let index = 0;
    let interval;
    const texts = getTexts();

    function changeText(idx) {
        document.querySelector('.announcement__text').innerText = texts[idx];
    }

    function startInterval() {
        interval = setInterval(() => {
            changeText(index);
            index = (index + 1) % texts.length;
        }, delay)
    }

    function stopInterval() {
        clearInterval(interval);
    }

    document.getElementById('previous').addEventListener('click', () => {
        stopInterval();
        index = index - 1 < 0 ? texts.length - 1 : index - 1;
        changeText(index);
        startInterval();
    });

    document.getElementById('next').addEventListener('click', () => {
        console.log('next');
        stopInterval();
        index = (index + 1) % texts.length;
        changeText(index);
        startInterval();
    });

    startInterval();
});